<script lang="ts">
	import StructuredData from "@components/common/StructuredData.svelte";
	import type { BreadcrumbList, ListItem } from "schema-dts";
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";
	import { appName } from "@core/schema/names/appName.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	interface Props {
		breadcrumbs: Breadcrumb[];
		canonicalUrl?: string;
	}

	const { breadcrumbs, canonicalUrl }: Props = $props();
	const { WEB_URL } = getGlobalSettings();
	const { tenant } = getGlobalTemplateProps();

	const allCrumbs = $derived<Breadcrumb[]>([{ label: appName, href: getHomepagePath(tenant) }, ...breadcrumbs]);

	const schema = $derived<BreadcrumbList>({
		"@type": "BreadcrumbList",
		itemListElement: allCrumbs.map(
			(crumb, index): ListItem => ({
				"@type": "ListItem",
				position: index + 1,
				name: crumb.label,
				...(crumb.href !== undefined
					? { item: `${WEB_URL}${crumb.href}` }
					: index === allCrumbs.length - 1 && canonicalUrl !== undefined
						? { item: canonicalUrl }
						: {}),
			}),
		),
	});
</script>

{#if breadcrumbs.length > 0}
	<StructuredData data={schema} />
{/if}
